import resource from 'resource-axios'
import axios from 'axios'

export const autoComplete = resource('/complete', {} , axios)


